import moment from "moment";

export const isoTimeFormat = (date) => {
  // console.log(date,"date");
  return moment(date, "YYYY-MM-DD HH:mm").toISOString();
};

// Return date & time 
export function formatDateTime(isoString, type = "date") {
  // console.log(isoString, "isoString");
  if (!isoString) return ""; // Handle empty input

  const date = new Date(isoString);

  const dateFormatter = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const timeFormatter = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  switch (type) {
    case "date":
      return dateFormatter.format(date); // Return only date
    case "time":
      return timeFormatter.format(date); // Return only time
    case "both":
      return `${dateFormatter.format(date)} ${timeFormatter.format(date)}`; // Return both date and time
    default:
      throw new Error("Invalid type. Use 'date', 'time', or 'both'.");
  }
}

// Add minute to time 
export function addMinutesToISODate(isoDateString, minutes) {
  if (!isoDateString || isNaN(minutes)) {
    throw new Error("Invalid input: Ensure both a valid ISO date string and number of minutes are provided.");
  }

  const date = new Date(isoDateString); // Convert ISO string to Date object
  date.setMinutes(date.getMinutes() + minutes); // Add the duration in minutes

  return date.toISOString(); // Convert back to ISO string and return
}

export const getTimeDifference = (start, end, unit = 'all') => {
  let startDate = moment(start);
  let endDate = moment(end);
  const duration = moment.duration(endDate.diff(startDate));

  // Helper function to return a formatted string if greater than 0
  const formatIfGreaterThanZero = (value, unitLabel) => {
    if (value > 0) {
      return `${value} ${unitLabel}`;
    }
    return ''; // Return an empty string if the value is 0 or less
  };

  switch (unit) {
    case 'days':
      return formatIfGreaterThanZero(duration.days(), 'days');
    case 'hours':
      return formatIfGreaterThanZero(duration.hours(), 'hours');
    case 'minutes':
      return formatIfGreaterThanZero(duration.minutes(), 'minutes');
    case 'all':
    default:
      // Build a string with the components that are greater than 0
      const days = formatIfGreaterThanZero(duration.days(), 'days');
      const hours = formatIfGreaterThanZero(duration.hours(), 'hours');
      const minutes = formatIfGreaterThanZero(duration.minutes(), 'minutes');

      // Join the components with commas (if any)
      return [days, hours, minutes].filter(Boolean).join(', ') || '0 minutes'; // Default to '0 minutes' if all values are 0
  }
};


export const isCurrentTimeInRange = (timeData) => {
  const currentTime = new Date(); // Get current time
  const startTime = new Date(timeData?.startDateTime); // Convert startDateTime to Date object
  const endTime = new Date(timeData?.endDateTime); // Convert endDateTime to Date object

  return currentTime >= startTime && currentTime <= endTime;
};

export const dateFormatWithTime = (date) => {
  return date ? moment(date).format('D MMM YYYY • h:mm A') : "-----"
}

//------------here-show-today-yesterday--then-monday-tuesday....---then-date----then--month-name---------------
export function formatFullDate(date) {
  if (!date) return;

  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const inputDate = new Date(date);

  let dayLabel;
  if (inputDate.toDateString() === today.toDateString()) {
    dayLabel = "Today";
  } else if (inputDate.toDateString() === yesterday.toDateString()) {
    dayLabel = "Yesterday";
  } else if (
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getFullYear() === today.getFullYear()
  ) {
    const day = String(inputDate.getDate()).padStart(2, '0');
    dayLabel = `${day}`;
  } else {
    const day = String(inputDate.getDate()).padStart(2, '0');
    const month = String(inputDate.getMonth() + 1).padStart(2, '0');
    const year = inputDate.getFullYear();
    dayLabel = `${day}/${month}/${year}`;
  }

  let hours = inputDate.getHours();
  const minutes = String(inputDate.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${dayLabel} - ${hours}:${minutes} ${ampm}`;
}


// Example usage:
// console.log(formatFullDate(new Date())); // Today
// console.log(formatFullDate(new Date(new Date().setDate(new Date().getDate() - 1)))); // Yesterday
// console.log(formatFullDate("2025-01-10T09:30:00")); // Specific date
